var mentions_default = {
  "mentionPalette": "dB3lV",
  "mention": "rMPkh",
  "mentionViewer": "XTWk8",
  "mentionSuggestionsEntry": "I9Fgx",
  "mentionSuggestionsEntryFocused": "_26D3b",
  "mentionSuggestionsEntryText": "AtyBN",
  "mentionSuggestionsEntryAvatar": "CuBiQ",
  "mentionSuggestions": "qKn2U",
  "cursorDefault": "vXC7k",
  "cursorPointer": "_3tSFv"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
